import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import http from '../components/http/http';
import { useTranslation } from 'react-i18next';

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState<string[] | null>(null);
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    setDetails(null);
    try {
      const data = await http.post('/api/users/auth/reset-password', {
        token,
        password,
        confirmPassword,
      });
      if (!data.success) {
        setError((data.errors && data.errors.join(', ')) || data.error || data.message || t('passwordResetFailed'));
        if (Array.isArray(data.details)) {
          setDetails(data.details);
        } else if (data.details && Array.isArray(data.details.errors)) {
          setDetails(data.details.errors);
        } else if (Array.isArray(data.errors)) {
          setDetails(data.errors);
        } else {
          setDetails(null);
        }
        setLoading(false);
        return;
      }
      setSuccess(data.message || t('passwordSuccessfullyChanged'));
      setLoading(false);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(t('networkError'));
      setDetails(null);
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8, background: '#fff' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontFamily: 'Roboto, sans-serif' }}>{t('resetPassword')}</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>{t('newPassword')}<br />
            <input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} placeholder={t('newPassword')} />
          </label>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>{t('confirmNewPassword')}<br />
            <input type="password" name="confirmPassword" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required style={{ width: '100%', padding: 8, marginTop: 4 }} placeholder={t('confirmNewPassword')} />
          </label>
        </div>
        {error && <div style={{ color: 'red', marginBottom: details ? 4 : 16 }}>{error}</div>}
        {details && details.length > 0 && (
          <ul style={{ color: 'red', marginBottom: 16, marginTop: 0, paddingLeft: 20 }}>
            {details.map((d, i) => <li key={i}>{d}</li>)}
          </ul>
        )}
        {success && <div style={{ color: 'green', marginBottom: 16 }}>{success}</div>}
        <div style={{ marginBottom: 16 }}>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 10,
              background: '#3baab0',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              fontWeight: 600,
              fontSize: 16,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
              opacity: loading ? 0.7 : 1
            }}
            onMouseOver={e => (e.currentTarget.style.background = '#329a9e')}
            onMouseOut={e => (e.currentTarget.style.background = '#3baab0')}
          >
            {loading ? t('resetting') : t('resetPassword')}
          </button>
        </div>
      </form>
      <div style={{ textAlign: 'center', marginTop: 24 }}>
        <span style={{ color: '#888', marginRight: 8 }}>{t('rememberedYourPassword')}</span>
        <button
          style={{
            marginTop: 0,
            padding: '8px 20px',
            background: '#fff',
            color: '#3baab0',
            border: '2px solid #3baab0',
            borderRadius: 4,
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            transition: 'background 0.2s, color 0.2s',
          }}
          onClick={() => navigate('/login')}
          onMouseOver={e => {
            e.currentTarget.style.background = '#3baab0';
            e.currentTarget.style.color = '#fff';
          }}
          onMouseOut={e => {
            e.currentTarget.style.background = '#fff';
            e.currentTarget.style.color = '#3baab0';
          }}
        >
          {t('logIn')}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword; 